import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'black-final-cta-section',
  templateUrl: './final-cta-section.component.html',
  styleUrls: ['./final-cta-section.component.css'],
  standalone: true,
  imports: [RouterModule],
})
export class FinalCtaSectionComponent {}
